// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

import "@hotwired/turbo-rails";
import "@fortawesome/fontawesome-free/js/all";
require("@rails/activestorage").start();
import "simplebar";
import "./components/direct_upload";
import "./controllers";
